import React from 'react';
import Client from './../components/Client';
import { ProSidebar, Menu as SidebarMenu, MenuItem as SidebarMenuItem, SubMenu } from 'react-pro-sidebar';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import ChatIcon from '@mui/icons-material/Chat';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import EuroIcon from '@mui/icons-material/Euro';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Visibility from './../Visibility';

class SideBar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      sideBar_collapsed: false,
      restricted: {},
      activeContent: props.activeContent || "stats",
      marketplaceOpen: props.activeContent === "marketplace"
    };

    this.toggleSideCollapsed = this.toggleSideCollapsed.bind(this);
    this.setActiveContent = this.setActiveContent.bind(this);
    this.restricted = new Visibility();
  }

  componentDidMount() {
    /* let restricted = new Visibility ();
    if (restricted) {
      this.setState ({restricted: restricted});
    }  */
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeContent !== this.props.activeContent) {
      this.setState({
        activeContent: this.props.activeContent || "stats",
        ...(this.props.activeContent === "marketplace" ? { marketplaceOpen: true } : {})
      });
    }
  }

  componentWillUnmount() {

  }

  toggleSideCollapsed() {
    let collapsed = !this.state.sideBar_collapsed;
    this.setState({ sideBar_collapsed: !this.state.sideBar_collapsed });
    this.props.toggleSideCollapsed(collapsed);
  }

  setActiveContent(e) {
    sessionStorage.setItem("activeContent", e);
    this.setState({ activeContent: e });
    if (this.props.setActiveContent) {
      this.props.setActiveContent(e);
    }
  }

  render() {

    let showPage = true;
    let restricted = this.restricted.getAllFalse();

    if (this.restricted)
      if (this.restricted.scope !== undefined && this.restricted.scope !== null)
        if (Object.keys(this.restricted.scope).length > 0)
          restricted = this.restricted.scope;

    const isActive = (content) => this.state.activeContent === content;
    const activeClass = (content) => isActive(content) ? "sidebar-menu-active" : "";
    const activeGroupClass = (...contents) => contents.some(content => isActive(content)) ? "sidebar-group-active" : "";
    const platforms_show = restricted.platforms?.visible && restricted.platforms.operations?.visible;

    let dashboard_show = false;
    let products_show = false;
    let products_products_show = false;
    let products_combos_show = false;
    let products_categories_show = false;
    let products_classes_show = false;

    let priceLists_show = false;
    let priceLists_locations_show = false;
    let priceLists_promotions_show = false;
    let priceLists_companies_show = false;
    let priceLists_products_show = false;
    let priceLists_combos_show = false;
    let priceLists_acquisitions_show = false;

    let magic_show = false;
    let magic_recom_show = false;
    let magic_promotions_show = false;
    let magic_directPromo_show = false;
    let magic_clientCredit_show = false;
    let magic_clientPromotionClaims_show = false;
    let magic_news_show = false;
    let magic_message_show = false;
    let magic_order_show = false;
    let magic_locOrders_show = false;
    let magic_feedback_show = false;

    let clients_show = false;
    let clients_accounts_show = false;
    let clients_families_show = false;
    let clients_professional_show = false;

    let locations_show = false;
    let locations_locations_show = false;
    let locations_external_references_show = false;
    let locations_groups_show = false;
    let locations_employees_show = false;

    let users_show = false;
    let users_internal_show = false;
    let users_clients_show = false;

    let registry_show = false;
    let registry_persons_show = false;
    let registry_companies_show = false;

    let config_show = false;
    let config_platform_show = false;
    let config_identity_show = false;
    let config_salesapp_show = false;
    let config_website_show = false;
    let config_website_identity_show = false;
    let config_mobileapp_show = false;
    let config_mobile_identity_show = false;
    let config_feedback_show = false;
    let config_product_show = false;

    let messages_show = false;
    let messages_internal_show = false;
    let messages_customers_show = false;

    let logs_show = false;
    let logs_pos_show = false;
    let logs_platform_show = false;
    let logs_customers_show = false;

    let biReports_show = false;
    let biReports_sales_show = false;
    let biReports_forecast_show = false;
    let biReports_products_show = false;
    let biReports_categories_show = false;
    let biReports_orders_show = false;
    let biReports_clients_show = false;
    let biReports_clientsActivity_show = false;
    let biReports_promotion_show = false;
    let biReports_transactions_show = false;
    let biReports_monthClose_show = false;
    let biReports_prodCost_show = false;
    let biReports_prodSupply_show = false;

    if (restricted.dashboard)
      if (restricted.dashboard.visible)
        dashboard_show = true;

    if (restricted.products) {
      if (restricted.products.visible)
        products_show = true;
      if (restricted.products.products)
        if (restricted.products.products.visible)
          products_products_show = true;
      if (restricted.products.combos)
        if (restricted.products.combos.visible)
          products_combos_show = true;
      if (restricted.products.categories)
        if (restricted.products.categories.visible)
          products_categories_show = true;
      if (restricted.products.classes)
        if (restricted.products.classes.visible)
          products_classes_show = true;
    }

    if (restricted.priceLists) {
      if (restricted.priceLists.visible)
        priceLists_show = true;
      if (restricted.priceLists.locations)
        if (restricted.priceLists.locations.visible)
          priceLists_locations_show = true;
      if (restricted.priceLists.companies)
        if (restricted.priceLists.companies.visible)
          priceLists_companies_show = true;
      if (restricted.priceLists.promotions)
        if (restricted.priceLists.promotions.visible)
          priceLists_promotions_show = true;
      if (restricted.priceLists.products)
        if (restricted.priceLists.products.visible)
          priceLists_products_show = true;
      if (restricted.priceLists.combos)
        if (restricted.priceLists.combos.visible)
          priceLists_combos_show = true;
      if (restricted.priceLists.acquisitions)
        if (restricted.priceLists.acquisitions.visible)
          priceLists_acquisitions_show = true;
    }

    if (restricted.magic) {
      if (restricted.magic.visible)
        magic_show = true;
      if (restricted.magic.recom)
        if (restricted.magic.recom.visible)
          magic_recom_show = true;
      if (restricted.magic.promotions)
        if (restricted.magic.promotions.visible)
          magic_promotions_show = true;
      if (restricted.magic.directPromo)
        if (restricted.magic.directPromo.visible)
          magic_directPromo_show = true;
      if (restricted.magic.clientCredit)
        if (restricted.magic.clientCredit.visible)
          magic_clientCredit_show = true;
      if (restricted.magic.clientPromotionClaims)
        if (restricted.magic.clientPromotionClaims.visible)
          magic_clientPromotionClaims_show = true;
      if (restricted.magic.news)
        if (restricted.magic.news.visible)
          magic_news_show = true;
      if (restricted.magic.message)
        if (restricted.magic.message.visible)
          magic_message_show = true;
      if (restricted.magic.order)
        if (restricted.magic.order.visible)
          magic_order_show = true;
      if (restricted.magic.locOrders)
        if (restricted.magic.locOrders.visible)
          magic_locOrders_show = true;
      if (restricted.magic.feedback)
        if (restricted.magic.feedback.visible)
          magic_feedback_show = true;
    }

    if (restricted.clients) {
      if (restricted.clients.visible)
        clients_show = true;
      if (restricted.clients.accounts)
        if (restricted.clients.accounts.visible)
          clients_accounts_show = true;
      if (restricted.clients.families)
        if (restricted.clients.families.visible)
          clients_families_show = true;
      if (restricted.clients.professional)
        if (restricted.clients.professional.visible)
          clients_professional_show = true;
    }

    if (restricted.locations) {
      if (restricted.locations.visible)
        locations_show = true;
      if (restricted.locations.locations)
        if (restricted.locations.locations.visible)
          locations_locations_show = true;
      if (restricted.locations.externalReferences)
        if (restricted.locations.externalReferences.visible)
          locations_external_references_show = true;
      if (restricted.locations.groups)
        if (restricted.locations.groups.visible)
          locations_groups_show = true;
      if (restricted.locations.employees)
        if (restricted.locations.employees.visible)
          locations_employees_show = true;
    }

    if (restricted.users) {
      if (restricted.users.visible)
        users_show = true;
      if (restricted.users.internal)
        if (restricted.users.internal.visible)
          users_internal_show = true;
      if (restricted.users.clients)
        if (restricted.users.clients.visible)
          users_clients_show = true;
    }

    if (restricted.registry) {
      if (restricted.registry.visible)
        registry_show = true;
      if (restricted.registry.persons)
        if (restricted.registry.persons.visible)
          registry_persons_show = true;
      if (restricted.registry.companies)
        if (restricted.registry.companies.visible)
          registry_companies_show = true;
    }

    if (restricted.config) {
      if (restricted.config.visible)
        config_show = true;
      if (restricted.config.platform)
        if (restricted.config.platform.visible)
          config_platform_show = true;
      if (restricted.config.identity)
        if (restricted.config.identity.visible)
          config_identity_show = true;
      if (restricted.config.salesapp)
        if (restricted.config.salesapp.visible)
          config_salesapp_show = true;
      if (restricted.config.website)
        if (restricted.config.website.visible)
          config_website_show = true;
      if (restricted.config.mobileapp)
        if (restricted.config.mobileapp.visible)
          config_mobileapp_show = true;
      if (restricted.config.mobile_identity)
        if (restricted.config.mobile_identity.visible) {
          config_mobile_identity_show = true;
          config_website_identity_show = true;
        }
      if (restricted.config.feedback)
        if (restricted.config.feedback.visible)
          config_feedback_show = true;
      if (restricted.config.product)
        if (restricted.config.product.visible)
          config_product_show = true;
    }

    if (restricted.messages) {
      if (restricted.messages.visible)
        messages_show = true;
      if (restricted.messages.internal)
        if (restricted.messages.internal.visible)
          messages_internal_show = true;
      if (restricted.messages.customers)
        if (restricted.messages.customers.visible)
          messages_customers_show = true;
    }

    if (restricted.logs) {
      if (restricted.logs.visible)
        logs_show = true;
      if (restricted.logs.pos)
        if (restricted.logs.pos.visible)
          logs_pos_show = true;
      if (restricted.logs.platform)
        if (restricted.logs.platform.visible)
          logs_platform_show = true;
      if (restricted.logs.customers)
        if (restricted.logs.customers.visible)
          logs_customers_show = true;
    }

    if (restricted.biReports) {
      if (restricted.biReports.visible)
        biReports_show = true;
      if (restricted.biReports.sales)
        if (restricted.biReports.sales.visible)
          biReports_sales_show = true;
      if (restricted.biReports.forecast)
        if (restricted.biReports.forecast.visible)
          biReports_forecast_show = true;
      if (restricted.biReports.products)
        if (restricted.biReports.products.visible)
          biReports_products_show = true;
      if (restricted.biReports.categories)
        if (restricted.biReports.categories.visible)
          biReports_categories_show = true;
      if (restricted.biReports.orders)
        if (restricted.biReports.orders.visible)
          biReports_orders_show = true;
      if (restricted.biReports.clients)
        if (restricted.biReports.clients.visible)
          biReports_clients_show = true;
      if (restricted.biReports.clientsActivity)
        if (restricted.biReports.clientsActivity.visible)
          biReports_clientsActivity_show = true;
      if (restricted.biReports.promotion)
        if (restricted.biReports.promotion.visible)
          biReports_promotion_show = true;
      if (restricted.biReports.transactions)
        if (restricted.biReports.transactions.visible)
          biReports_transactions_show = true;
      if (restricted.biReports.monthClose)
        if (restricted.biReports.monthClose.visible)
          biReports_monthClose_show = true;
      if (restricted.biReports.prodCost)
        if (restricted.biReports.prodCost.visible)
          biReports_prodCost_show = true;
      if (restricted.biReports.prodSupply)
        if (restricted.biReports.prodSupply.visible)
          biReports_prodSupply_show = true;
    }

    return (
      <div className="sideBar appSideBar">
        <style>
          {`
            .appSideBar {
              height: 100%;
              overflow: hidden;
            }

            /* Sidebar real width */
            .appSideBar .pro-sidebar {
              height: 100vh;
              max-height: 100vh;
            }

            .appSideBar .pro-sidebar-inner {
              height: 100vh;
              max-height: 100vh;
              overflow: hidden;
              background: linear-gradient(180deg, #243240 0%, #1f2b36 100%) !important;
            }

            /* Mobile expanded width */
            @media (max-width: 760px) {
              .appSideBar .pro-sidebar {
                width: 180px !important;
                min-width: 180px !important;
              }

              .appSideBar .pro-sidebar-inner {
                width: 180px !important;
                min-width: 180px !important;
              }
            }

            /* Scroll area */
            .appSideBar .pro-menu {
              height: calc(100vh - 8px);
              overflow-y: auto;
              overflow-x: hidden;
              padding-top: 4px !important;
              padding-bottom: 42px !important;
              scrollbar-width: thin;
            }

            .appSideBar .pro-menu::-webkit-scrollbar {
              width: 6px;
            }

            .appSideBar .pro-menu::-webkit-scrollbar-thumb {
              background: rgba(255, 255, 255, 0.22);
              border-radius: 10px;
            }

            .appSideBar .pro-menu::-webkit-scrollbar-track {
              background: transparent;
            }

            /* Main menu rows */
            .appSideBar .pro-inner-item {
              display: flex !important;
              align-items: center !important;
              margin: 1px 6px !important;
              padding: 4px 8px 4px 11px !important;
              border-radius: 8px;
              min-height: 30px;
              transition: background 0.15s ease, color 0.15s ease;
            }

            .appSideBar .pro-item-content {
              font-size: 13.75px !important;
              line-height: 1.2;
              letter-spacing: 0.02px;
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              white-space: nowrap !important;
              min-width: 0;
            }

            /* Icons */
            .appSideBar .pro-icon-wrapper {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              margin-right: 7px !important;
              min-width: 22px !important;
              width: 22px !important;
            }

            .appSideBar .pro-icon-wrapper svg {
              font-size: 17px !important;
            }

            /* Text color */
            .appSideBar .pro-menu-item {
              color: rgba(255, 255, 255, 0.78);
            }

            .appSideBar .pro-menu-item:hover {
              color: #ffffff;
            }

            .appSideBar .pro-menu-item:not(.sidebar-menu-active) > .pro-inner-item:hover {
              background: rgba(255, 255, 255, 0.08) !important;
            }

            /* Active item */
            .appSideBar .sidebar-menu-active > .pro-inner-item {
              background: rgba(245, 197, 66, 0.17) !important;
              box-shadow: inset 3px 0 0 #f5c542;
            }

            .appSideBar .sidebar-menu-active > .pro-inner-item,
            .appSideBar .sidebar-menu-active > .pro-inner-item .pro-item-content {
              color: #ffffff !important;
              font-weight: 500;
            }

            .appSideBar .sidebar-menu-active svg {
              color: #f5c542 !important;
            }

            /* Active group */
            .appSideBar .sidebar-group-active > .pro-inner-item {
              color: #ffffff !important;
              font-weight: 500;
              background: rgba(255, 255, 255, 0.055) !important;
            }

            .appSideBar .sidebar-group-active > .pro-inner-item svg {
              color: #f5c542 !important;
            }

            /* Submenu container */
            .appSideBar .pro-sub-menu .pro-inner-list-item {
              padding-left: 0 !important;
              background: rgba(0, 0, 0, 0.08) !important;
            }

            /* Submenu children */
            .appSideBar .pro-sub-menu .pro-inner-list-item .pro-inner-item {
              margin: 1px 6px 1px 12px !important;
              padding-left: 17px !important;
              padding-top: 3px !important;
              padding-bottom: 3px !important;
              min-height: 28px;
            }

            .appSideBar .pro-sub-menu .pro-inner-list-item .pro-item-content {
              font-size: 13.25px !important;
              line-height: 1.15;
              font-weight: 500;
            }

            /* Fix submenu arrow covering text */
            .appSideBar .pro-sub-menu > .pro-inner-item {
              padding-right: 36px !important;
            }

            .appSideBar .pro-sub-menu > .pro-inner-item .pro-arrow-wrapper {
              right: 10px !important;
              width: 18px !important;
              min-width: 18px !important;
            }

            .appSideBar .pro-sub-menu > .pro-inner-item .pro-arrow {
              border-width: 0 2px 2px 0 !important;
              padding: 3px !important;
            }

            /* Collapsed mode */
            .appSideBar .pro-sidebar.collapsed {
              width: 76px !important;
              min-width: 76px !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-sidebar-inner {
              width: 76px !important;
              min-width: 76px !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu {
              padding-top: 6px !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
              width: max-content;
              min-width: 180px !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > .popper-inner {
              padding-left: 6px;
              padding-right: 6px;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item .pro-inner-item {
              margin-left: 6px !important;
              padding-left: 8px !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
              display: flex !important;
              justify-content: center !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item {
              width: 46px !important;
              height: 42px !important;
              min-height: 42px !important;
              margin: 3px auto !important;
              padding: 0 !important;
              border-radius: 12px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
              margin: 0 !important;
              min-width: 46px !important;
              width: 46px !important;
              height: 42px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .pro-icon-wrapper svg {
              font-size: 20px !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .pro-item-content {
              display: none !important;
            }

            .appSideBar .pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .pro-arrow-wrapper {
              display: none !important;
            }

            .appSideBar .pro-sidebar.collapsed .sidebar-menu-active > .pro-inner-item {
              background: rgba(245, 197, 66, 0.18) !important;
              box-shadow: none !important;
            }

            .appSideBar .pro-sidebar.collapsed .sidebar-group-active > .pro-inner-item {
              background: rgba(255, 255, 255, 0.08) !important;
              box-shadow: none !important;
            }

            .appSideBar .pro-sidebar.collapsed .sidebar-menu-active > .pro-inner-item svg,
            .appSideBar .pro-sidebar.collapsed .sidebar-group-active > .pro-inner-item svg {
              color: #f5c542 !important;
            }
          `}
        </style>

        {showPage ?
          <ProSidebar collapsedWidth="70px" collapsed={this.state.sideBar_collapsed} sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <SidebarMenu iconShape="square" sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
              <SidebarMenuItem
                icon={this.state.sideBar_collapsed ? <FaChevronRight /> : <FaChevronLeft />}
                onClick={this.toggleSideCollapsed}
                sx={{ paddingTop: "0px", paddingBottom: "0px" }}
              >
                <Link to="/" />
              </SidebarMenuItem>

              {dashboard_show ?
                <SidebarMenuItem icon={<HomeIcon />} className={activeClass("stats")}>
                  Dashboard
                  <Link to="#" onClick={() => this.setActiveContent("stats")} />
                </SidebarMenuItem>
                : ""
              }

              {biReports_show ?
                <SubMenu
                  title="BI Report"
                  icon={<AnalyticsIcon />}
                  className={activeGroupClass(
                    "rap_sales",
                    "rap_sales2",
                    "rap_products",
                    "rap_products2",
                    "rap_orders",
                    "rap_clients",
                    "rap_clientsActivity",
                    "rap_promotion",
                    "rap_commercial_analysis",
                    "rap_cost",
                    "rap_supply",
                    "rap_trans",
                    "rap_close"
                  )}
                >
                  {biReports_sales_show ?
                    <SidebarMenuItem className={activeClass("rap_sales")}>
                      Sales
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_sales")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_forecast_show ?
                    <SidebarMenuItem className={activeClass("rap_sales2")}>
                      Forecast
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_sales2")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_products_show ?
                    <SidebarMenuItem className={activeClass("rap_products")}>
                      Products
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_products")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_categories_show ?
                    <SidebarMenuItem className={activeClass("rap_products2")}>
                      Categories
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_products2")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_orders_show ?
                    <SidebarMenuItem className={activeClass("rap_orders")}>
                      Orders
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_orders")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_clients_show ?
                    <SidebarMenuItem className={activeClass("rap_clients")}>
                      Clients
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_clients")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_clientsActivity_show ?
                    <SidebarMenuItem className={activeClass("rap_clientsActivity")}>
                      Engagement
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_clientsActivity")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_promotion_show ?
                    <SidebarMenuItem className={activeClass("rap_promotion")}>
                      Promotions
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_promotion")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_sales_show ?
                    <SidebarMenuItem title="Commercial Analysis" className={activeClass("rap_commercial_analysis")}>
                      Commercial
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_commercial_analysis")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_prodCost_show ?
                    <SidebarMenuItem className={activeClass("rap_cost")}>
                      ProdCost
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_cost")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_prodSupply_show ?
                    <SidebarMenuItem className={activeClass("rap_supply")}>
                      ProdSupply
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_supply")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_transactions_show ?
                    <SidebarMenuItem className={activeClass("rap_trans")}>
                      Transactions
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_trans")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {biReports_monthClose_show ?
                    <SidebarMenuItem className={activeClass("rap_close")}>
                      MonthClose
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_close")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {products_show ?
                <SubMenu
                  title="Products"
                  icon={<FastfoodIcon />}
                  className={activeGroupClass("products", "combos", "categories", "classes")}
                >
                  {products_products_show ?
                    <SidebarMenuItem className={activeClass("products")}>
                      Products
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("products")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {products_combos_show ?
                    <SidebarMenuItem className={activeClass("combos")}>
                      Combos
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("combos")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {products_categories_show ?
                    <SidebarMenuItem className={activeClass("categories")}>
                      Categories
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("categories")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {products_classes_show ?
                    <SidebarMenuItem className={activeClass("classes")}>
                      Classes
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("classes")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {priceLists_show ?
                <SubMenu
                  title="Price Lists"
                  icon={<EuroIcon />}
                  className={activeGroupClass(
                    "listsPrice",
                    "listsPromotion",
                    "listsCompany",
                    "listsProduct",
                    "listsCombo",
                    "listsAcquisition"
                  )}
                >
                  {priceLists_locations_show ?
                    <SidebarMenuItem className={activeClass("listsPrice")}>
                      Prices
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("listsPrice")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {priceLists_promotions_show ?
                    <SidebarMenuItem className={activeClass("listsPromotion")}>
                      Promotions
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("listsPromotion")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {priceLists_companies_show ?
                    <SidebarMenuItem className={activeClass("listsCompany")}>
                      Companies
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("listsCompany")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {priceLists_products_show ?
                    <SidebarMenuItem className={activeClass("listsProduct")}>
                      Products
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("listsProduct")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {priceLists_combos_show ?
                    <SidebarMenuItem className={activeClass("listsCombo")}>
                      Combos
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("listsCombo")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {priceLists_acquisitions_show ?
                    <SidebarMenuItem className={activeClass("listsAcquisition")}>
                      Acquisitions
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("listsAcquisition")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {magic_show ?
                <SubMenu
                  title="Magic"
                  icon={<AutoAwesomeIcon />}
                  className={activeGroupClass(
                    "recommendations",
                    "promotions",
                    "directPromo",
                    "clientCredit",
                    "clientPromotionClaims",
                    "news",
                    "message",
                    "order",
                    "rap_locorders",
                    "feedback"
                  )}
                >
                  {magic_recom_show ?
                    <SidebarMenuItem className={activeClass("recommendations")}>
                      Recom
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("recommendations")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_promotions_show ?
                    <SidebarMenuItem className={activeClass("promotions")}>
                      Promotions
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("promotions")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_directPromo_show ?
                    <SidebarMenuItem className={activeClass("directPromo")}>
                      DirectPromo
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("directPromo")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_clientCredit_show ?
                    <SidebarMenuItem className={activeClass("clientCredit")}>
                      ClientCredit
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("clientCredit")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_clientPromotionClaims_show ?
                    <SidebarMenuItem className={activeClass("clientPromotionClaims")}>
                      PromoClaims
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("clientPromotionClaims")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_news_show ?
                    <SidebarMenuItem className={activeClass("news")}>
                      News
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("news")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_message_show ?
                    <SidebarMenuItem className={activeClass("message")}>
                      Message
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("message")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_order_show ?
                    <SidebarMenuItem className={activeClass("order")}>
                      HQ Order
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("order")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_locOrders_show ?
                    <SidebarMenuItem className={activeClass("rap_locorders")}>
                      OrderHub
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("rap_locorders")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {magic_feedback_show ?
                    <SidebarMenuItem className={activeClass("feedback")}>
                      Feedback
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("feedback")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {clients_show ?
                <SubMenu
                  title="Clients"
                  icon={<ShoppingBagIcon />}
                  className={activeGroupClass("clientsAccounts", "clientsFamilies", "clientsProfessionals")}
                >
                  {clients_accounts_show ?
                    <SidebarMenuItem className={activeClass("clientsAccounts")}>
                      Accounts
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("clientsAccounts")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {clients_families_show ?
                    <SidebarMenuItem className={activeClass("clientsFamilies")}>
                      Families
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("clientsFamilies")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {clients_professional_show ?
                    <SidebarMenuItem className={activeClass("clientsProfessionals")}>
                      Professional
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("clientsProfessionals")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {locations_show ?
                <SubMenu
                  title="Locations"
                  icon={<EditLocationAltIcon />}
                  className={activeGroupClass("locations", "locations_groups", "employees")}
                >
                  {locations_locations_show ?
                    <SidebarMenuItem className={activeClass("locations")}>
                      Locations
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("locations")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {locations_groups_show ?
                    <SidebarMenuItem className={activeClass("locations_groups")}>
                      Groups
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("locations_groups")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {locations_employees_show ?
                    <SidebarMenuItem className={activeClass("employees")}>
                      Employees
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("employees")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {platforms_show &&
                <SubMenu
                  title="Platforms"
                  icon={<ShoppingBagIcon />}
                  className={activeGroupClass("marketplace")}
                  open={this.state.marketplaceOpen}
                  onOpenChange={() => this.setState(state => ({ marketplaceOpen: !state.marketplaceOpen }))}
                  aria-label="Platforms navigation"
                  aria-expanded={this.state.marketplaceOpen}
                >
                  <SidebarMenuItem className={activeClass("marketplace")}>
                    Operations
                    <Link to="#" aria-label="Platform Operations" aria-current={isActive("marketplace") ? "page" : undefined} onClick={() => this.setActiveContent("marketplace")} />
                  </SidebarMenuItem>
                </SubMenu>
              }

              {users_show ?
                <SubMenu
                  title="Users"
                  icon={<PeopleAltIcon />}
                  className={activeGroupClass("usersInternal", "usersClients")}
                >
                  {users_internal_show ?
                    <SidebarMenuItem className={activeClass("usersInternal")}>
                      Internal
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("usersInternal")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {users_clients_show ?
                    <SidebarMenuItem className={activeClass("usersClients")}>
                      Clients
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("usersClients")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {registry_show ?
                <SubMenu
                  title="Registry"
                  icon={<AssignmentIndIcon />}
                  className={activeGroupClass("addressBook_persons", "addressBook_companies")}
                >
                  {registry_persons_show ?
                    <SidebarMenuItem className={activeClass("addressBook_persons")}>
                      Persons
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("addressBook_persons")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {registry_companies_show ?
                    <SidebarMenuItem className={activeClass("addressBook_companies")}>
                      Companies
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("addressBook_companies")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {config_show ?
                <SubMenu
                  title="Config"
                  icon={<SettingsIcon />}
                  className={activeGroupClass(
                    "config_platform",
                    "config_identity",
                    "config_salesapp",
                    "config_website",
                    "config_website_identity",
                    "config_mobileapp",
                    "config_mobile_identity",
                    "config_feedback",
                    "config_product",
                    "locations_external_references"
                  )}
                >
                  {config_platform_show ?
                    <SidebarMenuItem className={activeClass("config_platform")}>
                      Platform
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_platform")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_identity_show ?
                    <SidebarMenuItem className={activeClass("config_identity")}>
                      Identity
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_identity")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_salesapp_show ?
                    <SidebarMenuItem className={activeClass("config_salesapp")}>
                      SalesApp
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_salesapp")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_website_show ?
                    <SidebarMenuItem className={activeClass("config_website")}>
                      WebSite
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_website")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_website_identity_show ?
                    <SidebarMenuItem className={activeClass("config_website_identity")}>
                      WebsiteIdentity
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_website_identity")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_mobileapp_show ?
                    <SidebarMenuItem className={activeClass("config_mobileapp")}>
                      MobileApp
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_mobileapp")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_mobile_identity_show ?
                    <SidebarMenuItem className={activeClass("config_mobile_identity")}>
                      MobIdentity
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_mobile_identity")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_feedback_show ?
                    <SidebarMenuItem className={activeClass("config_feedback")}>
                      Feedback
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_feedback")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {config_product_show ?
                    <SidebarMenuItem className={activeClass("config_product")}>
                      Product
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("config_product")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {locations_external_references_show ?
                    <SidebarMenuItem className={activeClass("locations_external_references")}>
                      External IDs
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("locations_external_references")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {messages_show ?
                <SubMenu
                  title="Messages"
                  icon={<ChatIcon />}
                  className={activeGroupClass("message", "news")}
                >
                  {messages_internal_show ?
                    <SidebarMenuItem className={activeClass("message")}>
                      Message
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("message")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {messages_customers_show ?
                    <SidebarMenuItem className={activeClass("news")}>
                      News
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("news")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }

              {logs_show ?
                <SubMenu
                  title="Logs"
                  icon={<SummarizeIcon />}
                  className={activeGroupClass("logs_pos", "logs_platform", "logs_customers")}
                >
                  {logs_pos_show ?
                    <SidebarMenuItem className={activeClass("logs_pos")}>
                      POS
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("logs_pos")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {logs_platform_show ?
                    <SidebarMenuItem className={activeClass("logs_platform")}>
                      Platform
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("logs_platform")} />
                    </SidebarMenuItem>
                    : ""
                  }
                  {logs_customers_show ?
                    <SidebarMenuItem className={activeClass("logs_customers")}>
                      Customers
                      <Link id="MenuItemHome" to="#" onClick={() => this.setActiveContent("logs_customers")} />
                    </SidebarMenuItem>
                    : ""
                  }
                </SubMenu>
                : ""
              }
            </SidebarMenu>
          </ProSidebar>
          : ""
        }
      </div>
    );

  }
}

export default SideBar;
